'use client';

import {
  HomeLandingSections,
  HomeStoriesSection,
  HomeCommunitySection,
  HomeVoicesSection,
  HomeAboutSection,
} from '@/components/homePageSections';

import { useState } from 'react';
import Header from '@/components/Header';
import HomeHeroSection from '@/components/HomeHeroSection';

export default function PavitraVivah() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  return (
    <div className="bg-white">
      {/* Transparent Header */}
      <Header variant="transparent" />

      <HomeHeroSection
        title="मराठी वधू-वरां साठी पवित्र विवाह सेवा देणारी"
        subtitle="महाराष्ट्रातील अग्रणी विवाहसंस्था"
        trackingSource="pavitra_vivah"
      />

      <HomeLandingSections />

      <HomeStoriesSection />

      <HomeCommunitySection />

      <HomeVoicesSection />

      <HomeAboutSection />

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
            Frequently Asked Questions
          </h2>
          <div className="max-w-4xl mx-auto">
            <div className="space-y-4">
              {[
                {
                  question: "Which is the best Vadhu Var Suchak Mandal Virar for free registration?",
                  answer: "MarathiVadhuVarSuchak.com is the best Vadhu Var Suchak Mandal for Marathi brides and grooms staying at Vasai and Virar."
                },
                {
                  question: "Which are the best Marathi matrimony sites in Maharashtra?",
                  answer: "There are multiple options, but from trust angel MarathiVadhuVarSuchak.com is the best choice to register free for Marathi bride and grooms."
                },
                {
                  question: "Which is the best Marathi Matrimony Thane for free registration?",
                  answer: "For Marathi community Vadhu Var staying at Thane region could register through MarathiVadhuVarSuchak.com Marathi matrimony site."
                },
                {
                  question: "Which is the trusted Vadhu Var Suchak Mandal Palghar region?",
                  answer: "For Marathi community brides and grooms staying at Palghar region could register a Marathi matrimony profile through MarathiVadhuVarSuchak.com or mobile app."
                },
                {
                  question: "How to join Vadhu Var Suchak Mandal Dadar WhatsApp Number group?",
                  answer: "No! Due to privacy policy, 'Marathi Vadhu Var Suchak' does not have Whatsapp group to join."
                },
                {
                  question: "How to download Marathi marriage bureau Vivah App?",
                  answer: "Marathi community brides and grooms can download 'Marathi Vadhu Var Suchak' app for free online registration."
                },
                {
                  question: "How much is the Marathi Vadhu Var Suchak fees?",
                  answer: "MarathiVadhuVarSuchak.com Marathi marriage bureau annual fees are Rs 2000 only. However, registration is free."
                },
                {
                  question: "How to do free registration for Marathi Vivah?",
                  answer: "Marathi Vadhu Var can visit MarathiVadhuVarSuchak.com site on install app for free registration."
                },
                {
                  question: "What is the Marathi Vadhu Var Suchak online signup process?",
                  answer: "Just visit MarathiVadhuVarSuchak.com a Marathi matrimony site or install an iOS or Android app for free online registration."
                }
              ].map((faq, index) => (
                <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                  <button
                    onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                    className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                  >
                    <h3 className="text-lg font-semibold text-gray-900">
                      {faq.question}
                    </h3>
                    <svg
                      className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${
                        openFAQ === index ? 'rotate-180' : ''
                      }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <div
                    className={`px-6 transition-all duration-300 ease-in-out ${
                      openFAQ === index ? 'pb-4 max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'
                    }`}
                  >
                    <div className="text-gray-600 leading-relaxed py-3">
                      <p className="mb-3">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Pavitra Vivah for Marathi Vadhu Var Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-gray-900 mb-8">
            Marathi Marriage Rituals - Why is it called Pavitra Vivah?
            </h2>
            <p className="text-gray-700 leading-relaxed" style={{ fontSize: '1.11rem' }}>
            In Marathi culture, marriage is not merely a social ceremony - it is revered as a Pavitra Vivah, a truly sacred and pure union blessed by God, ancestors, and the eternal forces of nature. Every ritual in a Marathi wedding, from the Sakhar Puda and Haldi to the holy Saptapadi and Mangalsutra Dharana, carries deep spiritual meaning that purifies the bond between Vadhu and Var at the soul level. The sacred fire - Agni - witnesses every vow, symbolizing truth, purity, and an unbreakable commitment that transcends this lifetime. The involvement of both families, the chanting of Vedic mantras by the Guruji, and the blessings of elders together elevate the ceremony beyond tradition into a divine experience. It is this layered sanctity - spiritual, cultural, and emotional - that makes every Marathi marriage truly deserving of the title Pavitra Vivah. At MarathiVadhuVarSuchak.com, we help you find a partner with whom you can begin this pure and blessed journey rooted in the pride of Marathi culture.
            </p>
          </div>
        </div>
      </section>

    </div>
  );
}

